package ru.villawonka.app.presentation.model

data class ConversationDetailsUIModel(
    val formula: String,
    val originalCost: Int,
    val originalCurrency: CurrencyUIModel,
    val displayCost: Int,
    val displayCurrency: CurrencyUIModel,
    val exchangeRate: Float,
)